import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutz­erklärung"
      eyebrow="Informationen gemäß DSGVO"
      lastUpdated="Dezember 2025"
    >
      <Section heading="1. Verantwortlicher">
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p>
          <strong className="text-white">Daniel Lopes Music UG (haftungsbeschränkt)</strong>
          <br />
          Tivolistraße 75
          <br />
          52349 Düren
          <br />
          Deutschland
          <br />
          E-Mail:{" "}
          <a
            href="mailto:booking@daniellopes.net"
            className="text-[#D4AF37] hover:underline"
          >
            booking@daniellopes.net
          </a>
        </p>
      </Section>

      <Section heading="2. Allgemeine Hinweise zur Datenverarbeitung">
        <p>
          Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich
          nur, soweit dies zur Bereitstellung einer funktions­fähigen Website
          sowie unserer Inhalte und Leistungen erforderlich ist. Die
          Verarbeitung erfolgt regelmäßig nur nach Einwilligung des Nutzers
          oder in den Fällen, in denen eine vorherige Einholung einer
          Einwilligung aus tatsächlichen Gründen nicht möglich ist und die
          Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.
        </p>
      </Section>

      <Section heading="3. Hosting und Server-Log-Dateien">
        <p>
          Diese Website wird auf Servern eines IT-Dienstleisters in der EU
          gehostet. Beim Aufruf der Seite werden automatisch Informationen
          (Server-Log-Dateien) erhoben:
        </p>
        <ul className="list-disc pl-5 space-y-1 text-[#C9C9C9]">
          <li>Anonymisierte IP-Adresse</li>
          <li>Datum und Uhrzeit des Zugriffs</li>
          <li>Browsertyp und -version</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer-URL</li>
        </ul>
        <p>
          Diese Daten werden zur Sicherstellung des technischen Betriebs sowie
          zur Abwehr von Angriffen verarbeitet (Rechtsgrundlage: Art. 6 Abs. 1
          lit. f DSGVO – berechtigtes Interesse). Die Daten werden nach
          spätestens 30 Tagen gelöscht.
        </p>
      </Section>

      <Section heading="4. Booking-Anfrageformular">
        <p>
          Wenn Sie uns über das Booking-Formular eine Anfrage zusenden, werden
          die folgenden Daten zur Bearbeitung Ihrer Anfrage gespeichert:
        </p>
        <ul className="list-disc pl-5 space-y-1 text-[#C9C9C9]">
          <li>Name</li>
          <li>E-Mail-Adresse</li>
          <li>Telefonnummer (optional)</li>
          <li>Firma / Agentur (optional)</li>
          <li>Event-Art, Datum, Ort, Budget</li>
          <li>Ihre Nachricht</li>
        </ul>
        <p>
          Die Verarbeitung erfolgt zur Anbahnung oder Durchführung eines
          Vertrags (Art. 6 Abs. 1 lit. b DSGVO). Ihre Daten werden in einer
          Datenbank gespeichert und ausschließlich zur Beantwortung Ihrer
          Anfrage verwendet. Eine Weitergabe an Dritte erfolgt nicht. Die
          Daten werden gelöscht, sobald sie für die Erreichung des Zweckes
          ihrer Erhebung nicht mehr erforderlich sind — spätestens jedoch
          nach Ablauf gesetzlicher Aufbewahrungsfristen.
        </p>
      </Section>

      <Section heading="5. Cookies">
        <p>
          Diese Website verwendet keine Tracking- oder Marketing-Cookies. Es
          werden lediglich technisch notwendige Sitzungs-Cookies eingesetzt,
          die für den Betrieb der Seite erforderlich sind. Eine Einwilligung
          ist hierfür nach § 25 Abs. 2 TTDSG nicht erforderlich.
        </p>
      </Section>

      <Section heading="6. Externe Inhalte (Streaming-Dienste)">
        <p>
          Auf unserer Seite verlinken wir zu Spotify, Apple Music, YouTube
          sowie Social-Media-Profilen (Instagram, YouTube). Erst beim Klick auf
          einen externen Link werden Daten an den jeweiligen Anbieter
          übertragen. Wir haben keinen Einfluss auf die dortige
          Datenverarbeitung; bitte beachten Sie die jeweiligen
          Datenschutzhinweise der Anbieter.
        </p>
      </Section>

      <Section heading="7. Ihre Rechte als betroffene Person">
        <p>
          Sie haben gemäß DSGVO folgende Rechte:
        </p>
        <ul className="list-disc pl-5 space-y-1 text-[#C9C9C9]">
          <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
        </ul>
        <p>
          Zur Ausübung dieser Rechte genügt eine formlose Nachricht an{" "}
          <a
            href="mailto:booking@daniellopes.net"
            className="text-[#D4AF37] hover:underline"
          >
            booking@daniellopes.net
          </a>
          .
        </p>
      </Section>

      <Section heading="8. Beschwerderecht bei der Aufsichtsbehörde">
        <p>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
          beschweren. Zuständig ist die Landesbeauftragte für Datenschutz und
          Informationsfreiheit Nordrhein-Westfalen, Kavalleriestr. 2–4, 40213
          Düsseldorf.
        </p>
      </Section>

      <Section heading="9. SSL-/TLS-Verschlüsselung">
        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
          Übertragung vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung.
          Eine verschlüsselte Verbindung erkennen Sie daran, dass die
          Adresszeile des Browsers von „http://" auf „https://" wechselt und
          am Schloss-Symbol in Ihrer Browserzeile.
        </p>
      </Section>

      <Section heading="10. Aktualität dieser Erklärung">
        <p>
          Diese Datenschutzerklärung ist aktuell gültig und hat den Stand
          Dezember 2025. Durch die Weiterentwicklung unserer Website kann es
          notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils
          aktuelle Datenschutzerklärung kann jederzeit auf dieser Seite
          eingesehen werden.
        </p>
      </Section>
    </LegalLayout>
  );
}
